import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col, Row } from 'antd';
import AuthButton from '../../Atoms/AuthButton';
import { TAuthInfoProps } from './definitions';
import Styles from './AuthInfo.module.scss';
import Image from 'Pages/Home/Components/Atoms/Image';
import Text from 'Pages/Home/Components/Atoms/Text';
import { useHistory } from 'react-router';
import { SidebarMenuContext } from 'Pages/Home/Context/SidebarMenuContext';
import DEFAULT_PROFILE from '../../../../../../images/profile-default.png';

export default function AuthInfo({ dataAuth }: TAuthInfoProps) {
  const history = useHistory();
  const { toggleMenuShow } = React.useContext(SidebarMenuContext);

  const onClickViewProfile = () => {
    history.push('/user_dashboard');
    toggleMenuShow(false);
  };

  const renderAuthInfo = () => (
    <Row className={Styles['profile-card']}>
      <Col>
        <Image
          src={
            dataAuth?.userdata?.img_url 
              ? dataAuth?.userdata?.img_url 
              : DEFAULT_PROFILE
          }
          className={Styles['profile-image']}
        />
      </Col>
      <Col className={Styles['profile-info']}>
        <Text className={Styles['profile-name']}>
          {dataAuth?.userdata.first_name} {dataAuth?.userdata.family_name}
        </Text>
        <Text className={Styles['profile-email']}>
          {dataAuth?.userdata.email}
        </Text>
        <Text className={Styles['profile-view']} onClick={onClickViewProfile}>
          View Profile
        </Text>
      </Col>
    </Row>
  );

  const renderAuthButton = () => (
    <Row align="middle" justify="space-between">
      <Col>
        <AuthButton type="login" />
      </Col>
      <Col>
        <AuthButton type="register" />
      </Col>
    </Row>
  );

  const authInfoRenderer = () => {
    return dataAuth?.isLogged ? renderAuthInfo() : renderAuthButton();
  };

  return (
    <div className={Styles['auth-info-container']}>{authInfoRenderer()}</div>
  );
}
